import React, { useEffect, useState, useRef, useContext } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { UserContext } from '../../../context/UserContext'
import ErrorMessage from "../../../common/ErrorMessage/ErrorMessage"
import { BASE_URL } from "../../../baseUrl"

const CustomDialog = ({ open, handleClose, dialogType, values }) => {

  /*const definition*/
  const [login, setLogin] = useContext(UserContext);
  const isLoggedIn = login.isLoggedIn;
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [namelocal, setNameLocal] = useState("");
  const [emaillocal, setEmailLocal] = useState("");
  const [citylocal, setCityLocal] = useState("");
  const [countrylocal, setCountryLocal] = useState("");
  const [categorylocal, setCategoryLocal] = useState("");
  const [idclientlocal, setID_ClientLocal] = useState("");
  const [biolocal,setBioLocal] = useState("");
  const [password,setPassword] = useState("");
  const [newpassword,setNewPassword] = useState("");
  const [emailconf,setEmailConf] = useState("");

  /*clean up variables*/

  const cleanFormData = () => {
      setNameLocal("");
      setEmailLocal("");
      setCityLocal("");
      setCountryLocal("");
      setBioLocal("");
      setPassword("");
      setNewPassword("")

  };

  useEffect(() => {

    if (open) {
      setEmailLocal(values.email || "");
      setNameLocal(values.fullname || "");
      setCityLocal(values.city || "");
      setCountryLocal(values.country || "");
      setCategoryLocal(values.category || "");
      setBioLocal(values.bio || "");
      setEmailConf(values.email_conf)
    }
  }, [open, values]);

  //const isBioOnly = dialogType === 0;

  /*Function to update profile data*/
  const handleUpdateProfile= async (e) => {
    e.preventDefault();
    const requestOptions = {
        method: "POST",
        headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + login.token},
        body: JSON.stringify({
                              Email: emaillocal,
                              Category: login.category,
                              Name: namelocal,
                              City: citylocal,
                              Country: countrylocal,
                              ID_Client:login.id_client,
                              ID_Corp: login.id_corp,
                              Bio:biolocal,
                              Email_conf: emailconf
                                  
                            })
      }

      const response = await fetch(BASE_URL + `/api/user/profile/${login.id_user}`,requestOptions);
      if (!response.ok) {
        setErrorMessage("Something went wrong when updating");
      } else {
        cleanFormData();
        handleClose()
      }
  }

  /*Function to update password*/
  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    try{
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + login.token,
          },
        };
         
        const body = {
            Email: emaillocal,
            hashed_pass: password,
            hashed_pass_new: newpassword,
          };
        console.log("update pass")
        console.log(body)
        await fetch(BASE_URL + "/api/change-password", {
            ...requestOptions,
            body: JSON.stringify(body),
        });

        cleanFormData()
        handleClose()

    } catch (error){
        setErrorMessage("Something went wrong when updating the password");
    }
 }
  
  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          handleClose();
        }
      }}
      ModalProps={{
        disableEnforceFocus: true,
      }}
      classes={{ paper: 'custom-dialog' }}
    >
      <DialogTitle>Update profile information</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Please Edit and click on Submit when done.
        </DialogContentText>
        {dialogType === 1 ? (
          <>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Full name"
              value = {namelocal}
              type="name"
              fullWidth
              variant="standard"
              onChange={(e) => setNameLocal(e.target.value)}
            />
            <TextField
              autoFocus
              margin="dense"
              id="email"
              label="Email Address"
              value = {emaillocal}
              type="email"
              fullWidth
              variant="standard"
              onChange={(e) => setEmailLocal(e.target.value)}
            />
            <TextField
              autoFocus
              margin="dense"
              id="city"
              label="City"
              value = {citylocal}
              type="city"
              fullWidth
              variant="standard"
              onChange={(e) => setCityLocal(e.target.value)}
            />
            <TextField
              autoFocus
              margin="dense"
              id="country"
              label="Country"
              value = {countrylocal}
              type="country"
              fullWidth
              variant="standard"
              onChange={(e) => setCountryLocal(e.target.value)}
            />
          </>
        ): dialogType === 0 ?(
            <TextField
                multiline
                margin="dense"
                rows={4}
                fullWidth
                label="Update Bio"
                value={biolocal}
                onChange={(e) => setBioLocal(e.target.value)}
            />
        ):(
          <>
            <TextField
              autoFocus
              margin="dense"
              id="pass"
              label="Current password"
              value = {password}
              type="password"
              fullWidth
              variant="standard"
              onChange={(e) => setPassword(e.target.value)}
            />
            <TextField
              autoFocus
              margin="dense"
              id="newpass"
              label="New password"
              value = {newpassword}
              type="password"
              fullWidth
              variant="standard"
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </>
        )}

      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        {dialogType === 2 ? (
          <Button onClick={handleUpdatePassword}>Submit</Button>
        ):(
          <Button onClick={handleUpdateProfile}>Submit</Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;